/** Test for feature flag being off */
import {features} from "@/app/Features";
import _ from 'underscore';

export default function(perm, arg1, options) {
    if (_(options).isUndefined()) options = arg1;
    if (!features[perm](arg1)) return options.fn(this);
    return options.inverse(this);
}